import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { getGideonPrayerPoints, getGideonEvents } from '../data/gideonSeed';

/**
 * Update user document with Gideon enlistment data.
 * Extends users/{uid} with Gideon-related fields.
 */
export const enlistGideon = async (userId, enlistmentData) => {
  const userRef = doc(db, 'users', userId);
  const userDoc = await getDoc(userRef);
  if (!userDoc.exists()) {
    throw new Error('User document not found');
  }

  const gideonFields = {
    isGideonMember: true,
    gideonStatus: 'enlisted',
    gideonJoinedAt: new Date(),
    gideonAgeGroup: enlistmentData.ageGroup || null,
    gideonDenomination: enlistmentData.denomination || null,
    gideonHomeChurch: enlistmentData.homeChurch || null,
    gideonAvailability: enlistmentData.availability || null,
    gideonPrayerTripletOptIn: enlistmentData.prayerTripletParticipation === true || enlistmentData.prayerTripletParticipation === 'yes',
    gideonPromotionsEmailOptIn: enlistmentData.promotionsEmailOptIn === true,
    gideonWhatsAppOptIn: enlistmentData.whatsappOptIn === true,
    gideonCommitmentsAccepted: true,
    updatedAt: new Date()
  };

  await updateDoc(userRef, gideonFields);
  return { success: true };
};

/**
 * Fetch Gideon prayer points. Ready for Firestore-first; falls back to local seed.
 */
export const fetchGideonPrayerPoints = async () => {
  try {
    // Future: read from gideonPrayerPoints collection
    // const snapshot = await getDocs(collection(db, 'gideonPrayerPoints'));
    // if (!snapshot.empty) return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    return getGideonPrayerPoints();
  } catch {
    return getGideonPrayerPoints();
  }
};

/**
 * Fetch Gideon events. Ready for Firestore-first; falls back to local seed.
 */
export const fetchGideonEvents = async () => {
  try {
    // Future: read from gideonEvents collection
    // const snapshot = await getDocs(collection(db, 'gideonEvents'));
    // if (!snapshot.empty) return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    return getGideonEvents();
  } catch {
    return getGideonEvents();
  }
};
